import { FC, useCallback, useState } from 'react';
import { useEventListener } from '@material-bank/ds-utils';
import { SplitFactory } from '@splitsoftware/splitio-react';

interface SplitProviderProps {
  children: JSX.Element;
}

export const SplitProvider: FC<SplitProviderProps> = (props) => {
  const { children } = props;

  const [splitFactory, setSplitFactory] = useState(window.splitFactory);

  const onSplitInitialized = useCallback(() => {
    setSplitFactory(window.splitFactory);
  }, []);

  useEventListener(window, 'split_initialized', onSplitInitialized);

  if (!splitFactory) {
    return <>{children}</>;
  }

  return <SplitFactory factory={splitFactory}>{children}</SplitFactory>;
};
